import React, { ReactNode } from "react";
import { createPortal } from "react-dom";

export type DeprecatedModalProps = {
  title?: string;
  description?: string;
  children: ReactNode;
  titleClasses?: string;
  contentClasses?: string;
  onBackdropClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onContentClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export function DeprecatedModal({
  title,
  description,
  children,
  titleClasses,
  contentClasses,
  onContentClick,
  onBackdropClick,
}: DeprecatedModalProps) {
  return createPortal(
    <div data-testid="modal">
      <div className="data-[state=open]:animate-overlay-show fixed inset-0 z-50" onClick={onBackdropClick} />
      <div
        className={`data-[state=open]:animate-content-show fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[450px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white p-[25px] shadow-[hsl(206_22%_7%/35%)_0px_10px_38px_-10px,hsl(206_22%_7%/20%)_0px_10px_20px_-15px] focus:outline-hidden z-51 ${contentClasses}`}
        onClick={onContentClick}
      >
        {title && <div className={`m-0 text-[17px] font-medium ${titleClasses}`}>{title}</div>}
        {description && <div className="pt-[10px] mb-5 text-[15px] leading-normal">{description}</div>}
        {children}
      </div>
    </div>,
    document.body
  );
}
